import { useCallback, useMemo, useState } from "react";
export { default as Drawer} from "@/components/Drawer";

export const useDrawer = (props) => {
    
    const { key = null, isOpen:_isOpen = false, ...rest} = props ?? {};

    const [isOpen, setIsOpen] = useState(_isOpen);

    const onOpen = useCallback(() => setIsOpen(true), []);
    const onClose = useCallback(() => setIsOpen(false), []);
    const onToggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);

    const drawerProps = useMemo(() => ({
        ...rest,
        key,
        name: key,
        isOpen,
        onClose,
    }), [key, rest, isOpen]);

    return {
        isOpen,
        drawerProps,
        onOpen,
        onClose,
        onToggle
    };
};